import React from 'react';
import './Unauthorized.css';

const Unauthorized = ({
    message,
    redirectTo
}) => {

    const redirect = (to) => {
        document.location.href = to;
    };

    React.useEffect(() => {
        if (redirectTo) {
            setTimeout(() => {
                redirect(redirectTo)
            }, 2*1000);
        }
    }, [redirectTo]);

    return (
        <div className="slc-unauthorized">
            { message }
        </div>
    );
};

export default Unauthorized;